import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import Spinner from '../mixins/spinner.mixins';

export const API_URL = 'https://apix.weborion.io/api';

const ApiService = {
  withLoading() {
    Spinner.methods.showLoading();
    return this;
  },
  init() {
    Vue.use(VueAxios, axios);
    Vue.axios.defaults.baseURL = API_URL;
  },

  get(resource, token = null) {
    return new Promise((resolve, reject) => {
      Vue.axios
        .get(`${resource}`, {
          cancelToken: token
        })
        .then(
          (response) => {
            resolve(response.data);
          },
          (error) => {
            reject(error);
          }
        );
    });
  },

  post(resource, params, config = {}) {
    return new Promise((resolve, reject) => {
      Vue.axios.post(`${resource}`, params, config).then(
        (response) => {
          if (response.status === 200 || response.status === 201) {
            resolve(response.data);
          } else {
            reject(response);
          }
        },
        (error) => {
          reject(error);
        }
      );
    });
  },

  put(resource, params) {
    return new Promise((resolve, reject) => {
      Vue.axios.put(`${resource}`, params).then(
        (response) => {
          resolve(response.data);
        },
        (error) => {
          reject(error);
        }
      );
    });
  },

  patch(resource, params) {
    return new Promise((resolve, reject) => {
      Vue.axios.patch(`${resource}`, params).then(
        (response) => {
          resolve(response.data);
        },
        (error) => {
          reject(error);
        }
      );
    });
  },

  delete(resource, config = null) {
    return new Promise((resolve, reject) => {
      Vue.axios.delete(`${resource}`, config).then(
        (response) => {
          if (response.status === 204) {
            resolve({});
          } else {
            resolve(response.data);
          }
        },
        (error) => {
          reject(error);
        }
      );
    });
  }
};

export default ApiService;
